import React from 'react';
import { useAuth } from 'react-oidc-context';

function Logout() {
  const auth = useAuth();

  React.useEffect(() => {
    // Clear all local storage
    localStorage.clear();
    // Trigger OIDC logout and redirect to sign-in
    auth.signoutRedirect();
  }, [auth]);

  return null;
}

export default Logout;
